import { createContext, useContext } from 'react';
import type { VideoFilters, VideoWithProspect } from '../types/prospect-media';

interface VideosContextValue {
  videos: VideoWithProspect[];
  /** Matches across the whole library, which can exceed the page held in `videos`. */
  totalCount: number;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
  /** Drops one video from the list after it has been deleted, without a refetch. */
  removeVideo: (videoId: string) => void;
  /** Filters currently narrowing `videos`. The list is already filtered server-side. */
  filters: VideoFilters;
  setFilters: React.Dispatch<React.SetStateAction<VideoFilters>>;
  clearFilters: () => void;
}

export const VideosContext = createContext<VideosContextValue | undefined>(undefined);

export function useVideosContext() {
  const context = useContext(VideosContext);
  if (!context) {
    throw new Error('useVideosContext must be used within VideosProvider');
  }
  return context;
}
